import React from 'react'
import { AlertCircleIcon, RefreshCwIcon } from 'lucide-react'

import { cn } from '@/lib/utils.ts'
import { Button } from '@/components/ui/button.tsx'

export interface ErrorStateProps {
  className?: string
  title?: React.ReactNode
  onRetry?: () => void
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  className,
  title = 'Si è verificato un errore',
  onRetry,
}) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center gap-2 py-10',
      className
    )}
  >
    <div className="mb-4 rounded-full bg-red-50 p-3">
      <AlertCircleIcon className="size-8 text-red-500" />
    </div>
    <div className="space-y-2 text-center">
      <h2 className="text-sm">{title}</h2>

      {onRetry && (
        <Button
          variant="outline"
          onClick={() => onRetry()}
          className="px-5 py-2 transition-all"
        >
          <RefreshCwIcon className="mr-2 size-4" />
          Riprova
        </Button>
      )}
    </div>
  </div>
)
